import useRouter from './useRouter'

export default (defaultTab: string = 'info'): [string, (tab: string) => any] => {
  const {
    history,
    match,
    location,
    query: { tab },
  } = useRouter()

  const activeTab = (tab as string) || defaultTab

  const setActiveTab = (newTab: string) => {
    // Preserve existing query params, just update the tab
    const params = new URLSearchParams(location.search)
    params.set('tab', newTab)
    history.replace(`${match.url}?${params.toString()}`)
  }

  return [activeTab, setActiveTab]
}
